import PropTypes from 'prop-types';
import React from 'react';
import DateSlider from '../containers/DateSlider';
import { timesShape } from '../../shapes';
import TimePicker from '../containers/TimePicker';

const DateTimePicker = ({
  times,
  selectedTime,
  setTime,
  timezone,
  noTimesAvailable,
  isFetching,
  serviceId,
  barberId,
  setActiveDay,
}) => (
  <div>
    <div className="o-wrapper o-wrapper--small">
      <DateSlider setActiveDay={setActiveDay} />
    </div>
    <div
      className="u-text-center u-mt large-and-up-mt large-and-up-pt-"
      style={{ minHeight: 20 }}
    >
      <TimePicker
        times={times}
        timezone={timezone}
        selectedTime={selectedTime}
        setTime={setTime}
        isFetching={isFetching}
        serviceId={serviceId}
        noTimesAvailable={noTimesAvailable}
        barberId={barberId}
      />
    </div>
  </div>
);
DateTimePicker.propTypes = {
  setActiveDay: PropTypes.func.isRequired,
  times: timesShape,
  selectedTime: PropTypes.string,
  setTime: PropTypes.func.isRequired,
  timezone: PropTypes.string,
  noTimesAvailable: PropTypes.bool,
  isFetching: PropTypes.bool,
  serviceId: PropTypes.string,
  barberId: PropTypes.string,
};
DateTimePicker.defaultProps = {
  times: [],
  selectedTime: '',
  timezone: null,
  noTimesAvailable: false,
  isFetching: false,
  anyBarber: false,
  serviceId: '',
  barberId: '',
};

export default DateTimePicker;




// WEBPACK FOOTER //
// ./src/app/times/components/DateTimePicker.jsx